import { useField } from 'formik'
import { camelCase } from 'lodash'
import { HeadingCombinationSettingType, HeadingType } from '../../common/types'
import { HeadingItemEditField, type CommonProps } from './HeadingItemEditField'
import { fieldNameWithParent } from './common'

export type { CommonProps }

interface Props extends CommonProps {
  showExperimentalFeatures: boolean
}

const NON_EXPERIMENTAL_HEADING_TYPES = [HeadingType.Pillar, HeadingType.Primary, HeadingType.Secondary]

const getHeadingList = (combinationType: string): string[] => {
  switch (combinationType) {
    case HeadingCombinationSettingType.OneHeading:
      return [HeadingType.Primary]
    case HeadingCombinationSettingType.Default:
      return [HeadingType.Primary, HeadingType.Secondary]
    case HeadingCombinationSettingType.TwoHeadingsSecondary:
      return [HeadingType.Secondary, HeadingType.Primary]
    case HeadingCombinationSettingType.TwoHeadingsPillar:
      return [HeadingType.Pillar, HeadingType.Primary]
    case HeadingCombinationSettingType.HHeadingHalfCenter:
    case HeadingCombinationSettingType.HHeadingSmallCenter:
    case HeadingCombinationSettingType.HHeadingMediumCenter:
    case HeadingCombinationSettingType.HHeadingLargeCenter:
    case HeadingCombinationSettingType.ThreeHeadingsCenter:
      return [HeadingType.Primary, HeadingType.Pillar, HeadingType.Secondary]
    default:
      return [HeadingType.Pillar, HeadingType.Primary, HeadingType.Secondary]
  }
}

export const OrderedHeadingCombinationFields = ({ showExperimentalFeatures, ...commonProps }: Props) => {
  const [typeField, ,] = useField(fieldNameWithParent('data.headingCombinationSettingType', 'rootHeading'))
  const headingsList = showExperimentalFeatures
    ? getHeadingList(camelCase(typeField.value))
    : NON_EXPERIMENTAL_HEADING_TYPES
  return headingsList?.map((type) => (
    <HeadingItemEditField key={`headings-${type}`} name={`headings.${type}`} {...commonProps} />
  ))
}
